import { useGetMonthlyExamEventOverviewQuery } from '@exam-center/graphql';
import { useNavigate, useParams } from '@exam-center/router';
import type { GridEventListener, GridRowParams } from '@shared/components';
import { useMemo } from 'react';

import { MonthlyExamEventDataGrid } from '../../components';
import type { MonthlyExamEventListItem } from '../../components/monthly-exam-event-data-grid/columns';

import { mapMonthlyExamEventOverviewToListItems } from './utils';

export default function MonthlyExamEventList() {
  const { examCenterCode, year } = useParams('/:examCenterCode/exam-events/years/:year');

  const navigate = useNavigate();

  const { data, loading: isGetMonthlyExamEventOverviewLoading } =
    useGetMonthlyExamEventOverviewQuery({
      variables: {
        getMonthlyExamEventOverviewInput: {
          examCenterCode,
          ictExamYear: parseInt(year),
        },
      },
      fetchPolicy: 'network-only',
    });

  const handleRowClick: GridEventListener<'rowClick'> = (
    params: GridRowParams<MonthlyExamEventListItem>,
  ) => {
    navigate('/:examCenterCode/exam-events/years/:year/months/:month', {
      params: {
        examCenterCode,
        year,
        month: params.row.month,
      },
    });
  };

  const overviewItems = useMemo(() => data?.ecGetMonthlyExamEventOverview.overview ?? [], [data]);

  const monthlyOverviewListItems = useMemo(
    () => mapMonthlyExamEventOverviewToListItems(overviewItems, parseInt(year)),
    [overviewItems, year],
  );

  return (
    <MonthlyExamEventDataGrid
      rows={monthlyOverviewListItems}
      onRowClick={handleRowClick}
      loading={isGetMonthlyExamEventOverviewLoading}
    />
  );
}
